import { get } from '../index';

export const getHealthCheck = (companyId) => {
  return get(`/model-health-report/${companyId}`);
};
